import Coa from '@tencent/Coa/index';
import RequestError from '@tencent/Coa/lib/RequestError';
import RequestErrorType from '@tencent/Coa/lib/RequestErrorType';
var filterRet0 = Coa.filterResponse(function (res) {
  if (res.ret !== 0) {
    try {
      var _window$aegis;
      (_window$aegis = window.aegis) === null || _window$aegis === void 0 ? void 0 : _window$aegis.vWarn({
        tag: 'redService请求错误[filterRet0]',
        error: res
      });
    } catch (_) {}
    throw new RequestError(res.ret, res.msg, res, RequestErrorType.SYSTEM_ERR);
  }
  return res;
});
var redServiceCoa = Coa(Coa.Retry(1), filterRet0);
export default function () {
  return redServiceCoa.run('//vip.video.qq.com/fcgi-bin/comm_cgi?name=spp_red_touch&cmd=1&red_touch_id_list=10007');
}